const newsfeedsConfig = {
    selector: 'mwNewsfeeds',
    template: `
        <section layout="column" id="mw-newsfeeds-table__content" class="mw-flex-padding">
            <mw-newsfeed-data-table ng-if="!$ctrl.isCardListVisible" on-show-cards="$ctrl.onChangeView()" on-edit-details="$ctrl.onEditDetails($event, item)"></mw-newsfeed-data-table>
            <md-button ng-if="$ctrl.permissions" aria-label="Add" class="mw-fab md-fab md-fab-bottom-right mw-fab--fixed" ng-click="$ctrl.onFabClick()">
                <md-icon md-svg-src="content:ic_add_24px"></md-icon>
                <md-tooltip md-direction="left">
                    <span translate>Create Newsfeed</span>
                </md-tooltip>
            </md-button>
        </section>
    `,
    controller: null
};

class NewsfeedsComponent {
    $window: any;
    $mdToast: any;
    $mdMedia: any;
    $mdDialog: any;
    $translate: any;
    selectedItem: any;
    items: any[];
    isCardListVisible: boolean;
    NewsfeedsService: any;
    $location: any;
    permissions: any;
    AppBarTitleService: any;

    constructor($window, $mdDialog, $mdToast, NewsfeedsService, $location, AppBarTitleService, $translate) {
        'ngInject';
        this.$window = $window;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.isCardListVisible = false;
        this.NewsfeedsService = NewsfeedsService;
        this.$location = $location;
        this.selectedItem;
        this.permissions = false;
        this.AppBarTitleService = AppBarTitleService;
        this.$translate = $translate;
    }

    $onInit() {
        this.AppBarTitleService.setCurrentTitle(this.$translate.instant('Outputs'));
        this.NewsfeedsService.getNewsfeedPermissions().then((permissions)=>{
            this.permissions = permissions;
        })
    }

    onEditDetails(event, item) {
        this.$location.url('/outputs/newsfeeds/edit/' + item._id + '?stepNum=0');
    }

    onFabClick($event) {
        this.$location.url('/outputs/newsfeeds/create');

    }

    onDialogOk(data) {
        let selectedItemIndex = this.items.indexOf(this.selectedItem);
        this.items.splice(selectedItemIndex, 1, data);
    }

    onDialogCancel() {

    }

    onChangeView() {
        this.isCardListVisible = !this.isCardListVisible;
        this.resetTableScroll();
    }

    resetTableScroll() {
        var element = this.$window.document.getElementById('mw-newsfeeds-table__content');
        if (element) {
            element.scrollTop = 0;
        }
    };
}

newsfeedsConfig.controller = NewsfeedsComponent;

export {
    newsfeedsConfig,
    NewsfeedsComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsfeeds/newsfeeds.component.ts
 **/